<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div>
        <div class="flex flex-wrap">
          <div
            v-if="!newEmergencyNumber"
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
          >
            Actualización de número de emergencia
          </div>
          <div
            v-if="newEmergencyNumber"
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
          >
            Nuevo número de emergencia
          </div>

          <div class="flex flex-col w-full pl-4">
            <form
              class="w-full max-w-lg"
              id="emergencyNumberForm"
              @submit.prevent
            >
              <div class="flex flex-wrap -mx-3">
                <div class="w-full px-3 mb-6">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="name"
                    >Nombre *</label
                  >
                  <input
                    :class="{ 'border-red-500': errors.name }"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="name"
                    type="text"
                    name="name"
                    v-model="emergencyNumber.nombre"
                  />
                  <p v-if="errors.name" class="text-red-500 text-xs italic">
                    Ingrese el nombre del número de emergencia.
                  </p>
                </div>
                <div class="w-full px-3 mb-6">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="number"
                    >Número *</label
                  >
                  <input
                    :class="{ 'border-red-500': errors.number }"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="number"
                    type="text"
                    name="number"
                    v-model="emergencyNumber.numero"
                  />
                  <p v-if="errors.number" class="text-red-500 text-xs italic">
                    Ingrese el número de emergencia.
                  </p>
                </div>
              </div>

              <div class="flex w-full justify-end">
                <button
                  class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveCategory()"
                >
                  Guardar
                </button>
                <button
                  class="ml-2 bg-red-500 hover:bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="close()"
                >
                  Cerrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Número de emergencia guardado exitosamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{ errors.codeError }}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";

export default {
  name: "emergency-number-modal",
  data() {
    return {
      aux_emergencyNumber: null,
      emergencyNumber: {
        nombre: null,
        numero: null,
        id: null,
      },
      errors: {
        name: false,
        number: false,
        codeError: "Ha ocurrido un error",
        icon_category: false,
        icon_extension: false,
        icon_dimension: false,
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      icons: [],
      srcUrl: "apidev",
      category_url: null,
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    newEmergencyNumber: {
      required: true,
      type: Boolean,
    },
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  mounted() {
    EventBus.$on("editModal", this.setData);
  },
  components: {
    AlertDialog,
  },
  methods: {
    reset: function () {
      this.emergencyNumber = {
        nombre: null,
        numero: null,
        id: null,
      };
      this.errors = {
        name: false,
        number: false,
        codeError: "Ha ocurrido un error",
      };
    },

    close() {
      this.reset();
      this.$emit("close");
    },
    setData: function (category) {
      this.emergencyNumber = Object.assign({}, category);
      this.aux_emergencyNumber = Object.assign({}, category);
    },

    saveCategory() {
      const form = document.getElementById("emergencyNumberForm");
      const signInData = new FormData(form);

      if (this.newEmergencyNumber) {
        const validForm = this.checkEmergencyNumberForm(signInData);

        if (validForm) {
          this.axios
            .post(
              "apidev/api/emergencynumbers/createnumber/",
              this.emergencyNumber,
              this.config
            )
            .then((response) => {
              return this.axios.post(
                "apidev/api/binnacles/monitor/save/",
                {
                  module: "Configuración",
                  action: "Creación de un número de emergencia",
                  observation: this.emergencyNumber.name,
                  email: localStorage.getItem("email"),
                },
                this.config
              );
            })
            .then(() => {
              this.showingSuccess = true;
              this.$emit("updateAllEmergencyNumbers");
              this.reset();
              this.$emit("close");
            })
            .catch((error) => {
              console.log(error.response);
              if (
                error.response.status == 400 ||
                error.response.status == 401
              ) {
                if (
                  error.response.data.name === "TokenExpiredError" ||
                  error.response.data.name === "InvalidTokenError" ||
                  error.response.data.name === "JsonWebTokenError"
                ) {
                  this.$router.push({ path: "/login" });
                }
              }
              if (error.response.status == 409) {
                this.errors.codeError =
                  "Ya hay otra categoría con ese nombre. Pruebe con otro nombre";
              }
              this.showingError = true;
            });
        }
      } else {
        const validForm = this.checkFormUpdateEmergencyNumber(signInData);
        if (validForm) {
          let updateData = {
            nombre: this.emergencyNumber.nombre,
            numero: this.emergencyNumber.numero,
          };

          this.axios
            .put(
                "apidev/api/emergencynumbers/updatenumber/" +
                this.emergencyNumber.id,
              updateData,
              this.config
            )
            .then((response) => {
              let observation = "";
              if (
                this.emergencyNumber.nobmre != this.aux_emergencyNumber.nombre
              ) {
                observation = `${this.aux_emergencyNumber.nombre} / ${this.emergencyNumber.nombre}`;
              } else {
                observation = `${this.emergencyNumber.nombre}`;
              }

              return this.axios.post(
                "apidev/api/binnacles/monitor/save/",
                {
                  module: "Configuración",
                  action: "Edición de un número de emergencia",
                  observation: observation,
                  email: localStorage.getItem("email"),
                },
                this.config
              );
            })
            .then(() => {
              this.showingSuccess = true;
              this.$emit("updateEmergencyNumberModal");
              this.reset();
              this.$emit("close");
            })
            .catch((error) => {
              if (
                error.response.status == 400 ||
                error.response.status == 401
              ) {
                if (
                  error.response.data.name === "TokenExpiredError" ||
                  error.response.data.name === "InvalidTokenError" ||
                  error.response.data.name === "JsonWebTokenError"
                ) {
                  this.$router.push({ path: "/login" });
                }
              }
              this.showingError = true;
            });
        }
      }
    },

    checkEmergencyNumberForm: function (signInData) {
      if (signInData.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (signInData.get("number") === "") {
        this.errors.number = true;
      } else {
        this.errors.number = false;
      }

      if (this.category_url === this.srcUrl + "/null") {
        this.errors.icon_category = true;
        this.errors.icon_extension = false;
        this.errors.icon_dimension = false;
      } else {
        this.errors.icon_category = false;
      }

      if (this.errors.name || this.errors.number || this.errors.icon_category) {
        return false;
      }

      return true;
    },

    checkFormUpdateEmergencyNumber: function (signInData) {
      if (signInData.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (signInData.get("number") === "") {
        this.errors.number = true;
      } else {
        this.errors.number = false;
      }

      if (this.category_url === this.srcUrl + "/null") {
        this.errors.icon_category = true;
        this.errors.icon_extension = false;
        this.errors.icon_dimension = false;
      } else {
        this.errors.icon_category = false;
      }

      if (this.errors.name || this.errors.number || this.errors.icon_category) {
        return false;
      }

      return true;
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
